import { signal } from '@preact/signals';

export const notificationCount = signal(0);
export const modifySignal = (value) => {
    return notificationCount.value = value
};